import React from "react";
import { MuiButton, MuiTypography, MuiToolTip } from '../../../ui/MaterialUIComponents';
import theme from '../../../../assests/theme';
import { makeStyles } from '@material-ui/core/styles';
import ReactExport from "react-data-export";
const useStyles = makeStyles(theme => ({

    printIconStyle: { height: '30', width: '25px' },
    iconButtonStyle: {
        "&:hover": {
            backgroundColor: theme.palette.primary.light
        },
        background: theme.palette.primary.main, width: '20px'
    },

}));
export default function GenerateTimeTableExcel(props) {
    const classes = useStyles();
    return (
        <MuiToolTip title={<MuiTypography style={{ fontSize: '14px', color: 'white', }}>{props.i18n.weeklyTimeTable.generateCSV}</MuiTypography>} arrow  >
            <MuiButton className={classes.iconButtonStyle} onClick={props.generateExcel}>
                <img src={theme.imageAlbum.excelIcon} className={classes.printIconStyle} />
            </MuiButton>
        </MuiToolTip>
    );
}
